import { render, staticRenderFns } from "./PainelComiteEspacoFisico.vue?vue&type=template&id=0bdad1f8"
import script from "./PainelComiteEspacoFisico.vue?vue&type=script&lang=js"
export * from "./PainelComiteEspacoFisico.vue?vue&type=script&lang=js"
import style0 from "./PainelComiteEspacoFisico.vue?vue&type=style&index=0&id=0bdad1f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports